var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "url(#paint0_linear_22400_64006)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 13C36.5523 13 37 13.4477 37 14C37 14.5523 36.5523 15 36 15H34V35H36C36.5523 35 37 35.4477 37 36C37 36.5523 36.5523 37 36 37H14C13.4477 37 13 36.5523 13 36C13 35.4477 13.4477 35 14 35H16V15H14C13.4477 15 13 14.5523 13 14C13 13.4477 13.4477 13 14 13H36ZM18 35H21V28C21 26.3431 22.3431 25 24 25H26C27.6569 25 29 26.3431 29 28V35H32V15H18V35ZM24 27C23.4477 27 23 27.4477 23 28V35H27V28C27 27.4477 26.5523 27 26 27H24ZM23 21C23.5523 21 24 21.4477 24 22C24 22.5523 23.5523 23 23 23H22C21.4477 23 21 22.5523 21 22C21 21.4477 21.4477 21 22 21H23ZM28 21C28.5523 21 29 21.4477 29 22C29 22.5523 28.5523 23 28 23H27C26.4477 23 26 22.5523 26 22C26 21.4477 26.4477 21 27 21H28ZM23 17C23.5523 17 24 17.4477 24 18C24 18.5523 23.5523 19 23 19H22C21.4477 19 21 18.5523 21 18C21 17.4477 21.4477 17 22 17H23ZM28 17C28.5523 17 29 17.4477 29 18C29 18.5523 28.5523 19 28 19H27C26.4477 19 26 18.5523 26 18C26 17.4477 26.4477 17 27 17H28Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22400_64006",
    x1: 50,
    y1: 0.00000160187,
    x2: -3.75,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443569,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyActive);
export default __webpack_public_path__ + "static/media/company-active.5f6428362f3d5055b24f1ffa0e2d7ab6.svg";
export { ForwardRef as ReactComponent };